<template>
  <div>

    <spinner-block v-model="progress">
      <promocode-table-block :list-data="listData"/>
    </spinner-block>
    <gui-paginate :data="listData" ref="paginate" @change="getList"/>
  </div>
</template>

<script>


import PromocodeTableBlock from "@/views/PromocodeUse/PromocodeTableBlock.vue";

export default {
  components: {PromocodeTableBlock},
  data() {
    return {
      listData: null,
      progress: null,
      filter: {
        subscription_id: null,
      }
    }
  },
  props: {
    data: Object,
  },
  mounted() {
    this.filter.subscription_id = this.data.id
    this.getList()
  },
  methods: {
    getList() {
      axiosGetValue('/api/admin/promocode-use/list', {
            filter: this.filter,
            page: this.$refs.paginate.currentPage,
            per_page: this.$refs.paginate.perPage,
          },
          e => this.listData = e, e => this.progress = e
      )
    },

  }
}
</script>
